define(function (require) {
    var $ = require("jquery");
    var apiUrl = window.scan && window.scan.apiUrl ? window.scan.apiUrl : "";

    var utility = require("@modules/tools/helpfulToolUtility");

    return {
        /**
         * Returns a jQuery promise for the formulary browse results.
         *
         * @param {} parameters Object of search parameters.
         * @returns {} Object with Copays array, Facets array.
         */
        getOptions: function (parameters) {
            /**
             * https://scanhealthplan.resultsbuilder.com/api/formularycopay/results?
             *      formularyId=66678&
             *      formularyyear=2018&
             *      plan=SCAN%20Classic%20(HMO)&
             *      year=2017&SubsidyLevel=Standard&
             *      state=CA&
             *      county=Ventura
             */

            return $.getJSON(apiUrl + "/api/formularycopay/results", parameters).then(function (results) {
                // console.dir(results);

                // re-map the Facets to abstract the structure
                results.Facets = {
                    Plan: utility.mapFacets(results.Facets.Plan),
                    Year: utility.mapFacets(results.Facets.Year),
                    State: utility.mapFacets(results.Facets.State),
                    County: utility.mapFacets(results.Facets.County),
                    SubsidyLevel: utility.mapFacets(results.Facets.SubsidyLevel)
                };

                if (results.Copays.hasOwnProperty("Preferred Pharmacy Network") && results.Copays.hasOwnProperty("Standard Pharmacy Network")) {
                    results.Copays = {
                        day30: {
                            mail: results.Copays["Mail Order Network"]["30 Day Supply"],
                            preferred: results.Copays["Preferred Pharmacy Network"]["30 Day Supply"],
                            standard: results.Copays["Standard Pharmacy Network"]["30 Day Supply"]
                        },
                        day60: {
                            mail: results.Copays["Mail Order Network"]["60 Day Supply"],
                            preferred: results.Copays["Preferred Pharmacy Network"]["60 Day Supply"],
                            standard: results.Copays["Standard Pharmacy Network"]["60 Day Supply"]
                        },
                        day90: {
                            mail: parseInt(parameters.year) >= 2021 ? results.Copays["Mail Order Network"]["100 Day Supply"] : results.Copays["Mail Order Network"]["90 Day Supply"],
                            preferred: parseInt(parameters.year) >= 2021 ? results.Copays["Preferred Pharmacy Network"]["100 Day Supply"] : results.Copays["Preferred Pharmacy Network"]["90 Day Supply"],
                            standard: parseInt(parameters.year) >= 2021 ? results.Copays["Standard Pharmacy Network"]["100 Day Supply"] : results.Copays["Standard Pharmacy Network"]["90 Day Supply"]
                        }
                    };
                }

                return results;
            });
        },

        getCounties: function (parameters) {
            if (!parameters.state) {
                const deferred = $.Deferred();
                deferred.resolve(null);
                return deferred.promise();
            }

            // console.log("pharmacyService: getting Counties");
            return $.getJSON(apiUrl + "/api/planfinderapi/counties", parameters, null, "json").then(function (results) {
                return Array.isArray(results) ? results : JSON.parse(results);
            });
        },
        getPlans: function (parameters) {
            if (!parameters.year || !parameters.state || !parameters.county) {
                const deferred = $.Deferred();
                deferred.resolve(null);
                return deferred.promise();
            }

            // console.log("pharmacyService: getting Plans");
            return $.getJSON(apiUrl + "/api/planfinderapi/getplans", parameters, null, "json").then(function (results) {
                return Array.isArray(results) ? results : JSON.parse(results);
            });
        }
    };
});
